import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { formatDateDDMMYYYY , toYYYYMMDD} from "utils/dateFormatter";

    function EditCareCoordinator({ isOpen, onRequestClose, id}) {

  const navigate = useNavigate();
  const [listDetails, setListDetails] = useState({

    firstname: "",
      lastname: "",
      imageMeta:"",
      image:"",
      phoneNumber: "",
      phonecountrycode: "",
      locationid:"",
     age:"",
     martialStatus:"",
     gender:"",
     certificationvalidtill:"",
     dob:"",
     nuid:"",
     nuidstatus:"",
  
  
  });
  const [loading, setLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [locations, setLocations] = useState([]);
  const countryCodes = [
  { code: "+91", name: "India" },
  { code: "+1", name: "USA" },
  { code: "+44", name: "UK" },
  { code: "+61", name: "Australia" },
  { code: "+971", name: "UAE" },
];
useEffect(() => {
  const fetchLocations = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const response = await axios.get("/api/location", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        setLocations(decrypted); // save locations in state
      }
    } catch (err) {
      console.error("Failed to fetch locations", err);
    }
  };
  

  fetchLocations();
}, []);

    const fetchCareCoordinatorDetails = async () => {
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        const response = await axios.get(`/api/carecoordinator/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
             const dob = decryptedData.dob;
             const certificationvalidtill=decryptedData.certificationvalidtill;

// Convert DD-MM-YYYY → YYYY-MM-DD
let formattedDOB = "";
if (dob && dob.includes("-")) {
  const [day, month, year] = dob.split("-");
  formattedDOB = `${year}-${month}-${day}`;
}

            let formattedcertificationvalidtill = "";
           if (certificationvalidtill && certificationvalidtill.includes("-")) {
              const [day, month, year] = certificationvalidtill.split("-");
               formattedcertificationvalidtill = `${year}-${month}-${day}`;
           }        

setListDetails({
  ...decryptedData,
  dob: formattedDOB,
  certificationvalidtill:formattedcertificationvalidtill

});
           
         // setListDetails(decryptedData);
          setOpenEditModal(true);
        }
      } catch (error) {
        console.error("Error fetching dealer details:", error);
        toast.error("Failed to fetch dealer details.");
      } finally {
        setLoading(false);
      }
    };

  

   useEffect(() => {
      if (isOpen) {
        fetchCareCoordinatorDetails();
        
      }

    }, [isOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setListDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

        // Convert YYYY-MM-DD → DD-MM-YYYY before saving
    const formattedDOB = formatDateDDMMYYYY(listDetails.dob);
     const formattedcertificationvalidtill = formatDateDDMMYYYY(listDetails.certificationvalidtill);
    const dataToSend = {
      ...listDetails,
      dob: formattedDOB, 
      certificationvalidtill:formattedcertificationvalidtill
    };

      const encryptedData = encryptBody(dataToSend, secretKey);
      const response = await axios.post("/api/carecoordinator/update", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        toast.success("CareCoorinator details updated successfully!");
        onRequestClose();      }
    } catch (error) {
      toast.error("Failed to update CareCoorinator details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <CircularProgress />
        </Box>
      )}

      <Modal open={isOpen}  onClose={onRequestClose}>
      <MDBox
  display="flex"
  justifyContent="center"
  alignItems="center"
  height="100vh"
  p={2}
>        <Card
  sx={{
    width: { xs: "95%", sm: "90%", md: "800px" }, 
    padding: 3,
    margin: "auto",
    marginTop: "5vh",
    maxHeight: "90vh",
    overflowY: "auto",
  }}
>            <MDBox pt={4} pb={3} px={3}>
              <MDTypography variant="h6" mb={4} textAlign="center">
                Update Care Coordinator Details:
              </MDTypography>

              <form onSubmit={handleSubmitEdit}>
                <Grid container spacing={3}>
 {/* Profile Photo Upload */}
<Grid item xs={12} style={{ textAlign: "center" }}>
  {listDetails?.image && (
    <img
      src={`data:image/*;base64,${listDetails.image}`}
      alt="Profile Preview"
      style={{
        width: "120px",
        height: "120px",
        borderRadius: "50%",
        objectFit: "cover",
        marginBottom: "10px",
      }}
    />
  )}

  {/* Upload Button */}
  <input
    accept="image/*"
    style={{ display: "none" }}
    id="upload-profile-photo"
    type="file"
    onChange={(e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setListDetails((prev) => ({
            ...prev,
            imageMeta: file.name,
            image: reader.result.split(",")[1], // base64
          }));
        };
        reader.readAsDataURL(file);
      }
    }}
  />
  <br/>
  <label htmlFor="upload-profile-photo">
    <MDButton
      component="span"
      style={{
        backgroundColor: "#2e7faeff",
        color: "#fff",
        textTransform: "none",
        minWidth: "160px",   // reduced length
        height: "36px",
      }}
    >
      Update Profile Photo
    </MDButton>
  </label>
</Grid>

                     <Grid item xs={6}>
                    <MDInput
                      type="text"
                      label="NUID"
                      fullWidth
                      name="nuid"
                      value={listDetails.nuid}
                      onChange={handleInputChange}
                      required
                       InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <MDButton
                                  onClick={() =>
                                    window.open("https://nrts.indiannursingcouncil.gov.in/login.nic", "_blank")
                                  }
                                  style={{
                                    backgroundColor: "#2e7faeff",
                                    color: "#fff",
                                    minWidth: "60px",
                                    height: "5px",
                                    fontSize: "12px",
                                    padding: "0px 4px",
                                     lineHeight: "1",
                                  }}
                                >
                                  Verify
                                </MDButton>
                              </InputAdornment>
                            ),
                          }}
                    />
                  </Grid>
                  <Grid item xs={6}>
  <TextField
    select
    fullWidth
    label="Nuid Status"
    name="nuidstatus"
    value={listDetails.nuidstatus}
    onChange={handleInputChange}
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    required
  >
    <MenuItem value="Active">Active</MenuItem>
    <MenuItem value="Inactive">Inactive</MenuItem>
    <MenuItem value="Pending">Pending</MenuItem>
  </TextField>
</Grid>
 <Grid item xs={6}>
                    <MDInput
                      type="text"
                      label="First Name"
                      fullWidth
                      name="firstname"
                      value={listDetails.firstname}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <MDInput
                      type="text"
                      label="Lastname"
                      fullWidth
                      name="lastname"
                      value={listDetails.lastname}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                 
                 <Grid item xs={6}>
                  <Grid container spacing={1}>
                      <Grid item xs={4}>
                     <TextField
        select
        label="Country Code"
        fullWidth
        value={listDetails.phonecountrycode}
        onChange={(e) =>
  setListDetails({
    ...listDetails,
    phonecountrycode: e.target.value,  // <-- correct key
  })
}

         sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    required
      >
          {countryCodes.map((item) => (
                  <MenuItem key={item.code} value={item.code}>
                    {`${item.name} (${item.code})`}
                  </MenuItem>
                ))}
       
      </TextField>
      </Grid>
      <Grid item xs={8}>
                    <MDInput
                      type="text"
                      label="Contact Number"
                      fullWidth
                      name="phoneNumber"
                      value={listDetails.phoneNumber}
                      onChange={handleInputChange}
                      required 
                    />
                  </Grid>

             </Grid>
             </Grid>

                 <Grid item xs={6}>
  <TextField
    select
    fullWidth
    label="Location"
    name="locationid"
    value={listDetails.locationid || ""}
    onChange={handleInputChange}
    sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    required
  >
    {locations.map((loc) => (
      <MenuItem key={loc.id} value={loc.id}>
        {`${loc.address}, ${loc.city}, ${loc.state}, ${loc.pin}, ${loc.country}`}
      </MenuItem>
    ))}
  </TextField>
  </Grid>



                  <Grid item xs={6}>
                    <MDInput
                      type="text"
                      label="Age"
                      fullWidth
                      name="age"
                      value={listDetails.age}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={6}>
    <TextField
      select
      fullWidth
      label="Marital Status"
      name="martialStatus"
      value={listDetails.martialStatus}
      onChange={handleInputChange}
      sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
      required
    >
      <MenuItem value="Single">Single</MenuItem>
      <MenuItem value="Married">Married</MenuItem>
      <MenuItem value="Divorced">Divorced</MenuItem>
      <MenuItem value="Widowed">Widowed</MenuItem>
    </TextField>
  </Grid>
                 <Grid item xs={6}>
    <TextField
      select
      fullWidth
      label="Gender"
      name="gender"
      value={listDetails.gender}
      onChange={handleInputChange}
      sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
      required
    >
      <MenuItem value="Male">Male</MenuItem>
      <MenuItem value="Female">Female</MenuItem>
      <MenuItem value="Other">Other</MenuItem>
    </TextField>
  </Grid>
                 
                  <Grid item xs={6}>
                    

                    <TextField
                      type="date"
                      label="Certification Valid Till"
                      name="certificationvalidtill"
                      fullWidth
                      value={listDetails.certificationvalidtill || ""}
                      onChange={(e) =>
                        setListDetails({ ...listDetails, certificationvalidtill: e.target.value })
                      }
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
      onKeyDown: (e) => e.preventDefault(), // disables typing manually
    }}
                      
                    />

                  </Grid>
                  <Grid item xs={6}>
                   <TextField
                     type="date"
                     label="Date Of Birth"
                     name="dob"
                     fullWidth
                     value={listDetails.dob || ""}
                     onChange={(e) =>
                       setListDetails({ ...listDetails, dob: e.target.value })
                     }
                     InputLabelProps={{ shrink: true }}
                       inputProps={{
      onKeyDown: (e) => e.preventDefault(), // disables typing manually
    }}
                   />
                  </Grid>
                 
                </Grid>
                
                <MDBox mt={3} textAlign="center">
                  <MDButton variant="gradient"  sx={{
    background: "#1976D2",
    color: "#fff",
    "&:hover": {
      background: "#1976D2", 
    },
  }} type="submit">
                    Update Care Coordinator
                  </MDButton>
                  &emsp;
                  <MDButton variant="gradient"  sx={{
    background: "#9E9E9E",
    color: "#fff",
    "&:hover": { 
      background: "#9E9E9E", // darker shade on hover
    },
  }} onClick={onRequestClose}>
                  Cancel
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>
          </Card>
        </MDBox>
      </Modal>
    </DashboardLayout>
  );
}

export default EditCareCoordinator;
